export default __webpack_public_path__ + "static/webRotator/svg/fabadbc9c08f7457a2ce5d5fee0083f1.svg";